import {combineReducers} from 'redux';
import alert from './alert';
import auth from './auth';
import programReducer from "./user_program";
import testReducer from "./user_test";
import instructionsReducer from "./instructions";
import assessmentReducer from "./user_assessment"
import userActiveExerciseReducer from './user_active_exercise';
import userActiveDayReducer from './user_active_day';

export default combineReducers({
    alert,
    auth,
    programReducer,
    testReducer,
    instructionsReducer,
    assessmentReducer,
    userActiveExerciseReducer,
    userActiveDayReducer,
});